import { render } from "./ShopSortingSheetComponent.vue?vue&type=template&id=2b3e8773&scoped=true"
import script from "./ShopSortingSheetComponent.vue?vue&type=script&lang=js"
export * from "./ShopSortingSheetComponent.vue?vue&type=script&lang=js"

import "./ShopSortingSheetComponent.vue?vue&type=style&index=0&id=2b3e8773&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3e8773"]])

export default __exports__